import { TreeViewConstants } from '@AMIEWEB/MarginTool/enum';
import { IEmailRecipients } from '@AMIEWEB/Notification/Constants';
import { missingDate, missingField } from 'app/constants';
import { AMNDivisionType } from 'app/models/enums/AMNDivisionType';
import { IEmployee, IToken } from 'app/models/Notification/Notification';
import { IPlacementDetails } from 'app/models/Placement/PlacementDetails';
import { isCandidateContractUser, userRoles } from 'oidc/userRoles';
import {
  IPlacementMarginEmailRecipientModal,
  IPlacementMarginEmailSenderModal,
  PlacementMarginPayPackageStatus,
  PlacementMarginScenarioStatus,
  PlacementMarginStatusTransitionButtons,
  PlacementMarginStatusTransitionModalType,
} from 'store/redux-store/margin-tool/slices/placement/placement-pay-package-status/placement-pay-package-status.model';
import { theme } from 'styles/global-styles';
import { EmailVariant } from './PayPackageHelper';
import {
  IPlacementMarginFurnitureCost,
  IPlacementMarginDetailsResponseScenarioSplitPayPackageDetailsValue,
  IPlacementMarginDetailsResponse,
  IPlacementMarginDetailsResponseScenario,
  IPlacementMarginDetailsResponseScenarioSplitItem,
} from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.model';
import { IScenarioSplitItem } from './AddScenario/model';
import { isUndefined, cloneDeep } from 'lodash';
import { formatDate, formatDateObj, getTlaShiftsPerWeek } from '@AMIEWEB/MarginTool/helper';
import { formatDateToStartOfDay } from 'app/helpers/dateHelper';
import i18next from 'i18next';
import { getExtensionDuration } from 'app/helpers/getExtensionDuration';
import moment from 'moment';
import { formattedNumber } from './PayPackagePreview/helper';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { PreviewContainerFieldNames } from './enum';
import { IPlacementMarginOverTimeHourlyRateItem } from '../../../../../store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.model';
import {
  getRatesWeeklyCalculatedValue,
  getFieldValue,
} from '../../../../components/MarginTool/Components/PayPackage/PayPackagePreview/helper';
import { IUserInfo } from 'oidc/user.redux';
import { Authorized } from 'oidc/userHelper';

export const getStatusTransitionEnabledUpdate = (statusId: number, userInfo: IUserInfo, isValid?: Boolean) => {
  if (statusId === PlacementMarginPayPackageStatus.Pending) {
    return [
      {
        button: PlacementMarginStatusTransitionButtons.RequestApproval,
        enabled: !isValid ? !isValid : true,
        show: true,
      },
      {
        button: PlacementMarginStatusTransitionButtons.Approve,
        enabled: Authorized(
          [
            userRoles.candidate_Contracts_Leadership,
            userRoles.candidate_Contracts_TeamMember,
            userRoles.recruitment_Leadership,
          ],
          userInfo,
        ),
        show: true,
      },
    ];
  } else if (statusId === PlacementMarginPayPackageStatus.ApprovalRequested) {
    return [
      {
        button: PlacementMarginStatusTransitionButtons.Approve,
        enabled: Authorized(
          [
            userRoles.candidate_Contracts_Leadership,
            userRoles.candidate_Contracts_TeamMember,
            userRoles.recruitment_Leadership,
          ],
          userInfo,
        ),
        show: true,
      },
      {
        button: PlacementMarginStatusTransitionButtons.reset,
        enabled: true,
        show: true,
      },
    ];
  } else if (statusId === PlacementMarginPayPackageStatus.Approved) {
    return [
      {
        button: PlacementMarginStatusTransitionButtons.verify,
        enabled: Authorized(
          [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
          userInfo,
        ),
        show: true,
      },
      {
        button: PlacementMarginStatusTransitionButtons.reset,
        enabled: true,
        show: true,
      },
    ];
  } else if (statusId === PlacementMarginPayPackageStatus.Verified) {
    return [
      {
        button: PlacementMarginStatusTransitionButtons.reset,
        enabled: true,
        show: true,
      },
    ];
  }
};
export const getTransitionStatusCategory = (type: PlacementMarginStatusTransitionModalType) => {
  switch (type) {
    case PlacementMarginStatusTransitionModalType.Deny:
      return PlacementMarginStatusTransitionModalType.Deny;
    case PlacementMarginStatusTransitionModalType.Approve:
    case PlacementMarginStatusTransitionModalType.RequestApproval:
      return PlacementMarginStatusTransitionModalType.Approve;
    default:
      return PlacementMarginStatusTransitionModalType.None;
  }
};

export const getModalTitle = (type: PlacementMarginStatusTransitionModalType, scenarioName: string) => {
  switch (type) {
    case PlacementMarginStatusTransitionModalType.Approve:
      return `Approve ${scenarioName}`;
    case PlacementMarginStatusTransitionModalType.Deny:
      return `Deny ${scenarioName}`;
    case PlacementMarginStatusTransitionModalType.RequestApproval:
      return `Submit for Approval ${scenarioName}`;
    default:
      return '';
  }
};

export const getPayPackageStatusChipColor = (val: number) => {
  switch (val) {
    case 1:
      return `${theme.palette.framework?.system?.lightOrange}`;
    case 2:
    case 3:
      return `${theme.palette.framework?.system?.lightViolet}`;
    case 4:
      return `${theme.palette.framework?.system?.lightGreen}`;
    default:
      return `${theme.palette.framework?.system?.lightOrange}`;
  }
};

export const getPayPackageStatusChipTextColor = (val: number) => {
  switch (val) {
    case 1:
      return `${theme.palette?.system?.orangeBrown}`;
    case 2:
    case 3:
      return `${theme.palette.framework?.system?.violet}`;
    case 4:
      return `${theme.palette?.system?.irishGreen}`;
    default:
      return `${theme.palette?.system?.orangeBrown}`;
  }
};

// temporary function to fetch the status name. Will be removed once pay package scenario data will be integrated
export const getPayPackageStatusName = (val: number) => {
  switch (val) {
    case 1:
      return 'Pending';
    case 2:
      return 'Approval Requested';
    case 3:
      return 'Approved';
    case 4:
      return 'Verified';
    default:
      return 'Pending';
  }
};

export const getStatusIdForUpdate = (type: PlacementMarginStatusTransitionModalType) => {
  if (type === PlacementMarginStatusTransitionModalType.Approve) {
    return PlacementMarginPayPackageStatus.Approved;
  } else if (type === PlacementMarginStatusTransitionModalType.RequestApproval) {
    return PlacementMarginPayPackageStatus.ApprovalRequested;
  } else if (type === PlacementMarginStatusTransitionModalType.Verify) {
    return PlacementMarginPayPackageStatus.Verified;
  } else if (type === PlacementMarginStatusTransitionModalType.Reset) {
    return PlacementMarginPayPackageStatus.Pending;
  } else {
    return PlacementMarginPayPackageStatus.Pending;
  }
};

export const getScenarioSplits = (selectedScenario: IPlacementMarginDetailsResponseScenario): IScenarioSplitItem[] => {
  return selectedScenario?.splits?.map(split => ({
    splitId: split?.splitId,
    mode: 2,
    startDate: formatDateToStartOfDay(split?.effectiveStartDate),
    endDate: formatDateToStartOfDay(split?.effectiveEndDate),
    shiftId: split?.shiftId,
    hoursPerWeek: split?.hoursPerWeek,
    hoursPerShift: split?.hoursPerShift,
  }));
};

export const convertToPercentage = (value: number) => {
  if (value === null || value === undefined) return `${missingField}%`;
  const percentage = value * 100;
  const rounded = Math.round(percentage * 100) / 100;
  return `${rounded.toFixed(2)}%`;
};

export const getAddScenarioButtonState = (
  placementIdParam,
  treeViewSelectedBookingPeriod,
  selectedBookingPeriod,
  t,
) => {
  let isDisabled = false;
  let tooltipMessage = '';
  let hasValidPlacementId = false;
  if (treeViewSelectedBookingPeriod?.placementId > 0) {
    hasValidPlacementId = true;
  }
  if (!hasValidPlacementId && placementIdParam > 0) {
    hasValidPlacementId = true;
  }
  if (!hasValidPlacementId) {
    return {
      state: true,
      message: t('marginTool.tooltip.disabledAddScenarioDueToPlacementIdNotAvailable'),
    };
  }

  if (selectedBookingPeriod) {
    if (selectedBookingPeriod?.scenarios?.length < TreeViewConstants.MAX_NUM_SCENARIOS) {
      selectedBookingPeriod?.scenarios?.forEach(each => {
        if (each?.scenarioStatusId !== PlacementMarginPayPackageStatus.Pending) {
          isDisabled = true;
          tooltipMessage = t('marginTool.tooltip.disabledAddScenarioDueToStatus');
        }
      });
    } else if (selectedBookingPeriod?.scenarios?.length >= TreeViewConstants.MAX_NUM_SCENARIOS) {
      isDisabled = true;
      tooltipMessage = t('marginTool.tooltip.disabledAddScenarioDueToLimit');
    }
  }

  return { state: isDisabled, message: tooltipMessage };
};

export const formatEmailRecipientsList = (
  scenarioStatus: number,
  selectEmailRecipients: IPlacementMarginEmailRecipientModal,
  sender: IEmployee,
  nextScenario: number,
) => {
  const isAMNNurse = selectEmailRecipients?.divisionId === AMNDivisionType.amnNurse;

  const emailRecipients: IEmailRecipients = {};
  if (scenarioStatus === PlacementMarginPayPackageStatus.Pending) {
    switch (nextScenario) {
      case PlacementMarginPayPackageStatus.ApprovalRequested:
        if (isAMNNurse) {
          emailRecipients.to = [getSenderObject(selectEmailRecipients?.recruiterDirector)];
          emailRecipients.cc = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.bcc = [sender];
        } else {
          emailRecipients.to = [getSenderObject(selectEmailRecipients?.recruiterDirector)];
          emailRecipients.cc = [];
          emailRecipients.bcc = [sender];
        }

        break;

      case PlacementMarginPayPackageStatus.Approved:
        if (isAMNNurse) {
          emailRecipients.to = [getSenderObject(selectEmailRecipients?.propelApprovers)];
          emailRecipients.cc = [getSenderObject(selectEmailRecipients?.recruiter)];
          emailRecipients.bcc = [sender];
        } else {
          emailRecipients.to = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.cc = [
            getSenderObject(selectEmailRecipients?.accountManager),
            getSenderObject(selectEmailRecipients?.clientContractAdmin),
            getSenderObject(selectEmailRecipients?.recruiter),
          ];
          emailRecipients.bcc = [sender];
        }
        break;
      default:
    }
  } else if (scenarioStatus === PlacementMarginPayPackageStatus.ApprovalRequested) {
    switch (nextScenario) {
      case PlacementMarginPayPackageStatus.Approved:
        if (isAMNNurse) {
          emailRecipients.to = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.cc = [getSenderObject(selectEmailRecipients?.recruiter)];
          emailRecipients.bcc = [sender];
        } else {
          emailRecipients.to = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.cc = [
            getSenderObject(selectEmailRecipients?.accountManager),
            getSenderObject(selectEmailRecipients?.clientContractAdmin),
            getSenderObject(selectEmailRecipients?.recruiter),
          ];
          emailRecipients.bcc = [sender];
        }
        break;
    }
  }

  return emailRecipients;
};

export const formatManualRecipientList = (
  scenarioStatus: number,
  selectEmailRecipients: IPlacementMarginEmailRecipientModal,
  sender: IEmployee,
  variant: string,
  candidateDetails: IPlacementMarginEmailSenderModal,
) => {
  const isAMNNurse = selectEmailRecipients?.divisionId === AMNDivisionType.amnNurse;

  const emailRecipients: IEmailRecipients = {};
  if (variant === EmailVariant.Internal) {
    switch (scenarioStatus) {
      case PlacementMarginPayPackageStatus.Pending:
        emailRecipients.to = [];
        emailRecipients.cc = [];
        emailRecipients.bcc = [sender];
        break;
      case PlacementMarginPayPackageStatus.ApprovalRequested:
        if (isAMNNurse) {
          emailRecipients.to = [getSenderObject(selectEmailRecipients?.recruiterDirector)];
          emailRecipients.cc = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.bcc = [sender];
        } else {
          emailRecipients.to = [getSenderObject(selectEmailRecipients?.recruiterDirector)];
          emailRecipients.cc = [];
          emailRecipients.bcc = [sender];
        }

        break;

      case PlacementMarginPayPackageStatus.Approved:
        if (isAMNNurse) {
          emailRecipients.to = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.cc = [getSenderObject(selectEmailRecipients?.recruiter)];
          emailRecipients.bcc = [sender];
        } else {
          emailRecipients.to = [
            getSenderObject(selectEmailRecipients?.propelApprovers),
            getSenderObject(selectEmailRecipients?.candidateContract),
          ];
          emailRecipients.cc = [
            getSenderObject(selectEmailRecipients?.accountManager),
            getSenderObject(selectEmailRecipients?.clientContractAdmin),
            getSenderObject(selectEmailRecipients?.recruiter),
          ];
          emailRecipients.bcc = [sender];
        }
        break;
      case PlacementMarginPayPackageStatus.Verified:
        emailRecipients.to = [];
        emailRecipients.cc = [];
        emailRecipients.bcc = [sender];
        break;
      default:
    }
  } else if (variant === EmailVariant.Candidate) {
    emailRecipients.to = [candidateDetails];
    emailRecipients.cc = [];
    emailRecipients.bcc = [sender];
  }
  //There will be additional checks in furure hence added else if
  return emailRecipients;
};

export const getSenderObject = user => {
  if (!user) return null;
  const sender: IPlacementMarginEmailSenderModal = {
    name: user?.firstName + ' ' + user?.lastName,
    email: user?.email,
    senderId: `${user?.employeeId}`,
    userId: `${user?.employeeId}`,
    editFlag: true,
  };
  return sender;
};

export const getCandidateDetails = (placementDetails: IPlacementDetails) => {
  if (!placementDetails?.header?.candidate?.id) return null;
  const user = placementDetails?.header;
  const sender: IPlacementMarginEmailSenderModal = {
    name: user?.candidate?.firstName + ' ' + user?.candidate?.lastName,
    email: user?.candidatePrimaryEmail,
    senderId: ``,
    userId: ``,
    editFlag: true,
  };
  return sender;
};

export const getTotalReimbursement = (selectedScenario: IPlacementMarginDetailsResponseScenario, brand?: string) => {
  const pickListTotal = selectedScenario?.assignment?.payPackageDetailsValues?.reduce((acc, item) => {
    let total = acc;

    const isExcluded = brand === 'AMN Allied' && item?.pickListDescription === 'Miscellaneous Medical or Lab Work';

    if (!isExcluded && item?.payPackageValues?.amount) {
      if (!isNullOrUndefined(item?.payPackageValues?.amount) && item?.payPackageValues?.amount !== 0) {
        total += item.payPackageValues.amount;
      }
    }

    return total;
  }, 0);
  const travelDetail = selectedScenario?.assignment?.travel;
  return (
    travelDetail?.arrivingTravel +
    travelDetail?.endingTravel +
    travelDetail?.interimTravel +
    travelDetail?.amnFlight +
    travelDetail?.amnRentalCar +
    pickListTotal
  );
};

export const getSubstitutions = values => {
  const substitutions: IToken[] = [
    {
      name: 'Signature',
      input: '{{signature}}',
    },
    {
      name: 'FirstName',
      input: '{{firstName}}',
      value: values?.firstName,
    },
    {
      name: 'LastName',
      input: '{{lastName}}',
      value: values?.lastName,
    },
    {
      name: 'Assignment',
      input: '{{assignment}}',
      value: values?.assignment,
    },
    {
      name: 'Shift',
      input: '{{shift}}',
      value: values?.shift,
    },
    {
      name: 'Location',
      input: '{{location}}',
      value: values?.location,
    },
    {
      name: 'Benefit',
      input: '{{benefitStatus}}',
      value: values?.benefit,
    },
    {
      name: 'Arriving Travel',
      input: '{{arrivingTravel}}',
      value: values?.arrivingTravel ? String(values?.arrivingTravel) : undefined,
    },
    {
      name: 'Ending Travel',
      input: '{{endingTravel}}',
      value: values?.endingTravel ? String(values?.endingTravel) : undefined,
    },
    {
      name: 'Interim Travel',
      input: '{{interimTravel}}',
      value: values?.interimTravel ? String(values?.interimTravel) : undefined,
    },
    {
      name: 'AMN Flight',
      input: '{{flight}}',
      value: values?.flight ? String(values?.flight) : undefined,
    },
    {
      name: 'AMN Rental Car',
      input: '{{rentalCar}}',
      value: values?.rentalCar ? String(values?.rentalCar) : undefined,
    },
    {
      name: 'Total',
      input: '{{total}}',
      value: values?.total,
    },
    {
      name: 'Total Reimbursement',
      input: '{{totalReimbursement}}',
      value: values?.totalReimbursement,
    },
    {
      name: 'Total Weekly Gross',
      input: '{{totalWeeklyGross}}',
      value: values?.totalWeeklyGross,
    },
    {
      name: 'Est. Total Net Pay',
      input: '{{estimatedTotalNetPay}}',
      value: values?.estimatedTotalNetPay,
    },
  ];
  return substitutions;
};

const getTotalGross = (item: IPlacementMarginDetailsResponseScenarioSplitItem) => {
  const tlaShiftsPerWeek = getTlaShiftsPerWeek(item?.hoursPerWeek, item?.hoursPerShift);
  const totalGross =
    item?.payRate * item?.hoursPerWeek +
    item?.mealPerDiem * 7 +
    item?.lodgingPerDiem * 7 +
    item?.tlaCarAllowance * tlaShiftsPerWeek +
    item?.tlaMealAllowance * tlaShiftsPerWeek;
  const cellPhoneStipend = item?.cellPhoneStipend
    ? item?.cellPhoneStipend * 7
    : item?.tlaCellPhoneStipend * tlaShiftsPerWeek;

  return totalGross + cellPhoneStipend;
};

const getTLASumAmount = (tlaItem: number, tlaEnabled: boolean, hoursPerWeek: number, hoursPerShift: number) => {
  if (
    tlaEnabled &&
    !isNullOrUndefined(tlaItem) &&
    !isNullOrUndefined(hoursPerWeek) &&
    !isNullOrUndefined(hoursPerShift)
  ) {
    return String(formattedNumber((tlaItem * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift))?.toFixed(2)));
  } else {
    return undefined;
  }
};

const getSplitRate = (item: number) => {
  return !isNullOrUndefined(item) ? String(item.toFixed(2)) : undefined;
};

const getTLASplitRate = (item: number, tlaEnabled: boolean) => {
  return tlaEnabled && !isNullOrUndefined(item) ? String(item.toFixed(2)) : undefined;
};

export const roundToTwoDecimals = value => {
  return value !== null && value > 0 ? Math.round(value * 100) / 100 : 0;
};

export const formatNumber = (value: number | string | null | undefined, minDecimals = 2): string => {
  if (value === null || value === undefined) return '0.00';

  // Try to convert string to number if needed
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numericValue)) return '0.00';

  const fixed = numericValue.toFixed(minDecimals); // "1.000", "0.670", etc.
  const trimmed = fixed.replace(/\.?0+$/, ''); // remove trailing zeroes

  const [intPart, decimalPart = ''] = trimmed.split('.');

  if (decimalPart.length === 1) return `${intPart}.${decimalPart}0`;
  if (decimalPart.length === 0) return `${intPart}.00`;
  return trimmed;
};

export const getNumberMatchStatusAsYesNo = (valueA, valueB): string => {
  return valueA || valueB ? (valueA === valueB ? 'Yes' : 'No') : '';
};

export const getSplitData = (
  splits: IPlacementMarginDetailsResponseScenarioSplitItem[],
  tlaEnabled: boolean,
  existingRates: IPlacementMarginOverTimeHourlyRateItem[],
  payPackageDetailsValues,
) => {
  let splitsWithAdditionalPremiumPay = getSplitsWithAdditionalPremium(splits, payPackageDetailsValues) || [];
  const splitResults = splitsWithAdditionalPremiumPay?.map((item, index) => {
    let totalWeeklyGross = 0;
    let estWeeklyNet = 0;
    const hoursPerWeek = item?.hoursPerWeek;
    const hoursPerShift = item?.hoursPerShift;
    const currSplitRates = existingRates?.find(x => x?.splitId === item?.splitId);

    let overtimeRate = getFieldValue({
      fieldName: PreviewContainerFieldNames.overTimeRate,
      currSplitRates,
      eachSplit: item,
    });
    let doubleTimeRate = getFieldValue({
      fieldName: PreviewContainerFieldNames.doubletimeRate,
      currSplitRates,
      eachSplit: item,
    });
    let premiumPayRate = getFieldValue({
      fieldName: PreviewContainerFieldNames.premiumPayRate,
      currSplitRates,
      eachSplit: item,
    });
    let payRateCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.payRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let overtimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.overTimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let premiumPayCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.premiumPayRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let doubletimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.doubletimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });

    const additionalPremiumPay =
      item?.additionalPremiumPay?.object?.id === 0 ? 0 : Number(item?.additionalPremiumPay?.object?.description);

    if (payRateCalculatedValue) {
      totalWeeklyGross += payRateCalculatedValue;
      estWeeklyNet += payRateCalculatedValue * 0.75;
    }
    if (overtimeCalculatedValue) {
      totalWeeklyGross += overtimeCalculatedValue;
      estWeeklyNet += overtimeCalculatedValue * 0.75;
    }
    if (premiumPayCalculatedValue) {
      totalWeeklyGross += premiumPayCalculatedValue;
      estWeeklyNet += premiumPayCalculatedValue * 0.75;
    }
    if (doubletimeCalculatedValue) {
      totalWeeklyGross += doubletimeCalculatedValue;
      estWeeklyNet += doubletimeCalculatedValue * 0.75;
    }

    if (tlaEnabled) {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCarAllowance)) {
        const carAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCarAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGross += carAllowance;
        estWeeklyNet += carAllowance * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaMealAllowance)) {
        const mealAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaMealAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGross += mealAllowance;
        estWeeklyNet += mealAllowance * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaShiftCompletionBonus)) {
        const shiftCompletionBonus =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaShiftCompletionBonus]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGross += shiftCompletionBonus;
        estWeeklyNet += shiftCompletionBonus * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCellPhoneStipend)) {
        const cellPhoneStipend =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCellPhoneStipend]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGross += cellPhoneStipend;
        estWeeklyNet += cellPhoneStipend;
      }
    } else {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.mealPerDiem)) {
        totalWeeklyGross += roundToTwoDecimals(item[PreviewContainerFieldNames.mealPerDiem]) * 7;
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.mealPerDiem]) * 7;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.lodgingPerDiem)) {
        totalWeeklyGross += roundToTwoDecimals(item[PreviewContainerFieldNames.lodgingPerDiem]) * 7;
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.lodgingPerDiem]) * 7;
      }

      if (item?.hasOwnProperty(PreviewContainerFieldNames.cellPhoneStipend)) {
        totalWeeklyGross += roundToTwoDecimals(item[PreviewContainerFieldNames.cellPhoneStipend]) * 7;
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.cellPhoneStipend]) * 7;
      }
    }

    const assignmentStartDate = !isUndefined(item?.effectiveStartDate)
      ? formatDateObj(item?.effectiveStartDate)
      : formatDate(missingDate);
    const assignmentEndDate = !isUndefined(item?.effectiveEndDate)
      ? formatDateObj(item?.effectiveEndDate)
      : formatDate(missingDate);
    //const totalWeeklyGross = getTotalGross(item);
    let phoneRate = undefined;
    let phoneStipend = undefined;
    if (item?.cellPhoneStipend && !tlaEnabled) {
      phoneRate = getSplitRate(item?.cellPhoneStipend);
      phoneStipend = String((item?.cellPhoneStipend * 7).toFixed(2));
    } else if (item?.tlaCellPhoneStipend && tlaEnabled) {
      phoneRate = getTLASplitRate(item?.tlaCellPhoneStipend, tlaEnabled);
      phoneStipend = getTLASumAmount(item?.tlaCellPhoneStipend, tlaEnabled, item?.hoursPerWeek, item?.hoursPerShift);
    }

    return {
      paySplitNumber: String(index + 1),
      assignment: assignmentStartDate + ' - ' + assignmentEndDate,
      shift: item?.shift,
      hourPerWeek: String(item?.hoursPerWeek),
      hourPerShift: String(item?.hoursPerShift),
      hourlyRate: getSplitRate(item?.payRate),
      hourlyPayRate: payRateCalculatedValue ? String(formattedNumber(payRateCalculatedValue?.toFixed(2))) : undefined,
      mealRate: getSplitRate(item?.mealPerDiem),
      mealPerDiem: item?.mealPerDiem
        ? String(formattedNumber((roundToTwoDecimals(item?.mealPerDiem) * 7)?.toFixed(2)))
        : undefined,
      lodgingRate: getSplitRate(item?.lodgingPerDiem),
      lodgingPerDiam: item?.lodgingPerDiem
        ? String(formattedNumber((roundToTwoDecimals(item?.lodgingPerDiem) * 7)?.toFixed(2)))
        : undefined,
      carRate: getTLASplitRate(item?.tlaCarAllowance, tlaEnabled),
      carAllowance: getTLASumAmount(item?.tlaCarAllowance, tlaEnabled, item?.hoursPerWeek, item?.hoursPerShift),
      mealAllowanceRate: getTLASplitRate(item?.tlaMealAllowance, tlaEnabled),
      mealAllowance: getTLASumAmount(item?.tlaMealAllowance, tlaEnabled, item?.hoursPerWeek, item?.hoursPerShift),
      shiftCompletionBonus: getTLASplitRate(item?.tlaShiftCompletionBonus, tlaEnabled),
      completionBonus: getTLASumAmount(
        item?.tlaShiftCompletionBonus,
        tlaEnabled,
        item?.hoursPerWeek,
        item?.hoursPerShift,
      ),
      cellPhoneRate: phoneRate,
      cellPhoneStipend: phoneStipend,
      totalWeeklyGross: String(formattedNumber(totalWeeklyGross?.toFixed(2))),
      weeklyNet: String(formattedNumber(estWeeklyNet?.toFixed(2))),
      housingType: item?.housingType,
      standardFurniture: item?.standardFurniture > 0 ? String(item?.standardFurniture) : undefined,
      additionalFurnitureCount:
        getStandardFurniture(item?.furnitureCosts) > 0 ? String(getStandardFurniture(item?.furnitureCosts)) : undefined,
      showPaySplit: splits?.length > 1 ? String(item?.splitId) : undefined,
      onCallRate:
        item?.payOnCallRate && Number(item?.payOnCallRate) > 0
          ? `On Call Rate: $${String(formatNumber(Number(item.payOnCallRate), 2))}/hr`
          : undefined,
      callBackRate:
        item?.payRate && Number(item?.payRate) > 0 && item?.payCallBackFactor && Number(item?.payCallBackFactor) > 0
          ? `Call Back Rate: $${String(
              formatNumber((1 + Number(item.payCallBackFactor)) * Number(item.payRate), 2),
            )}/hr`
          : undefined,
      mileage:
        item?.payAmountPerMile && Number(item?.payAmountPerMile) > 0
          ? `Mileage: $${String(formatNumber(Number(item.payAmountPerMile), 3))}/mile`
          : undefined,
      showPayRateSubLabels:
        getSplitRate(item?.payRate) &&
        Number(getSplitRate(item?.payRate)) > 0 &&
        ((item?.payOnCallRate && Number(item?.payOnCallRate) > 0) ||
          (item?.payRate &&
            Number(item?.payRate) > 0 &&
            item?.payCallBackFactor &&
            Number(item?.payCallBackFactor) > 0) ||
          (item?.payAmountPerMile && Number(item?.payAmountPerMile) > 0))
          ? String(true)
          : undefined,
      overtimeRate: String(overtimeRate.toFixed(2)),
      dailyOvertimeRateLabel:
        currSplitRates?.payOvertimeLimitDay && currSplitRates?.payOvertimeLimitDay > 0
          ? `Daily: Min.of $${formatNumber(overtimeRate, 2)}/hr after ${
              currSplitRates?.payOvertimeLimitDay
            } hours in a day.`
          : undefined,
      weeklyOvertimeRateLabel:
        currSplitRates?.payOvertimeLimitWeek && currSplitRates?.payOvertimeLimitWeek > 0
          ? `Weekly: Min.of $${formatNumber(overtimeRate, 2)}/hr after ${
              currSplitRates?.payOvertimeLimitWeek
            } hours in a week.`
          : undefined,
      overtimeValue: overtimeCalculatedValue > 0 ? String(overtimeCalculatedValue.toFixed(2)) : undefined,
      showBothOvertimeLabels:
        overtimeRate &&
        Number(overtimeRate) > 0 &&
        currSplitRates?.payOvertimeLimitDay &&
        currSplitRates?.payOvertimeLimitDay > 0 &&
        currSplitRates?.payOvertimeLimitWeek &&
        currSplitRates?.payOvertimeLimitWeek > 0
          ? String(true)
          : undefined,
      premiumPayRate:
        additionalPremiumPay && Number(additionalPremiumPay) > 0 ? String(premiumPayRate.toFixed(2)) : undefined,
      weeklyPremiumPayRateLabel:
        additionalPremiumPay && Number(additionalPremiumPay) > 0
          ? `Weekly: Min.of $${formatNumber(premiumPayRate, 2)}/hr after ${
              currSplitRates?.payOvertimeLimitWeek
            } hours in a week.`
          : undefined,
      premiumPayRateValue: premiumPayCalculatedValue > 0 ? String(premiumPayCalculatedValue.toFixed(2)) : undefined,
      doubletimeRate: String(doubleTimeRate.toFixed(2)),
      dailydoubletimeRateLabel:
        currSplitRates?.payDoubletimeLimitDay && currSplitRates?.payDoubletimeLimitDay > 0
          ? `Daily: Min.of $${formatNumber(doubleTimeRate, 2)}/hr after ${
              currSplitRates?.payDoubletimeLimitDay
            } hours in a day.`
          : undefined,
      doubletimeRateValue: doubletimeCalculatedValue > 0 ? String(doubletimeCalculatedValue.toFixed(2)) : undefined,
      tlaPerMode: tlaEnabled ? 'shift' : 'day',
    };
  });
  return splitResults;
};

export const getReimbursement = (
  payPackageDetailsValues: IPlacementMarginDetailsResponseScenarioSplitPayPackageDetailsValue[],
  brand?: string,
) => {
  const reimbursementValues = payPackageDetailsValues
    ?.filter(item => (brand === 'AMN Allied' ? item.pickListDescription !== 'Miscellaneous Medical or Lab Work' : true))
    .map(item => ({
      pickListLabel: item?.pickListDescription,
      pickListValue: item?.payPackageValues?.amount
        ? String(formattedNumber(item?.payPackageValues?.amount?.toFixed(2)))
        : undefined,
    }));

  return reimbursementValues;
};

export const totalWeeklyGross = (
  splits: IPlacementMarginDetailsResponseScenarioSplitItem[],
  tlaEnabled: boolean,
  existingRates: IPlacementMarginOverTimeHourlyRateItem[],
  payPackageDetailsValues,
) => {
  let splitsWithAdditionalPremiumPay = getSplitsWithAdditionalPremium(splits, payPackageDetailsValues) || [];
  return splitsWithAdditionalPremiumPay?.reduce((acc, item) => {
    const duration = getExtensionDuration(moment(item?.effectiveStartDate), item?.effectiveEndDate);
    let totalWeeklyGrossItem = 0;
    const hoursPerWeek = item?.hoursPerWeek;
    const hoursPerShift = item?.hoursPerShift;

    const currSplitRates = existingRates?.find(x => x?.splitId === item?.splitId);

    let payRateCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.payRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let overtimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.overTimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let premiumPayCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.premiumPayRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let doubletimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.doubletimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });

    if (payRateCalculatedValue) {
      totalWeeklyGrossItem += payRateCalculatedValue;
    }
    if (overtimeCalculatedValue) {
      totalWeeklyGrossItem += overtimeCalculatedValue;
    }
    if (premiumPayCalculatedValue) {
      totalWeeklyGrossItem += premiumPayCalculatedValue;
    }
    if (doubletimeCalculatedValue) {
      totalWeeklyGrossItem += doubletimeCalculatedValue;
    }
    if (tlaEnabled) {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCarAllowance)) {
        const carAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCarAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGrossItem += carAllowance;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaMealAllowance)) {
        const mealAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaMealAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGrossItem += mealAllowance;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCellPhoneStipend)) {
        const cellPhoneStipend =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCellPhoneStipend]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGrossItem += cellPhoneStipend;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaShiftCompletionBonus)) {
        const shiftCompletionBonus =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaShiftCompletionBonus]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        totalWeeklyGrossItem += shiftCompletionBonus;
      }
    } else {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.mealPerDiem)) {
        totalWeeklyGrossItem += roundToTwoDecimals(item[PreviewContainerFieldNames.mealPerDiem]) * 7;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.lodgingPerDiem)) {
        totalWeeklyGrossItem += roundToTwoDecimals(item[PreviewContainerFieldNames.lodgingPerDiem]) * 7;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.cellPhoneStipend)) {
        totalWeeklyGrossItem += roundToTwoDecimals(item[PreviewContainerFieldNames.cellPhoneStipend]) * 7;
      }
    }
    const weeklyTotal = totalWeeklyGrossItem * duration;
    return acc + weeklyTotal;
  }, 0);
};

export const totalWeeklyEstWeeklyNet = (
  splits: IPlacementMarginDetailsResponseScenarioSplitItem[],
  tlaEnabled: boolean,
  existingRates: IPlacementMarginOverTimeHourlyRateItem[],
  payPackageDetailsValues,
) => {
  let splitsWithAdditionalPremiumPay = getSplitsWithAdditionalPremium(splits, payPackageDetailsValues) || [];

  return splitsWithAdditionalPremiumPay?.reduce((acc, item) => {
    const duration = getExtensionDuration(moment(item?.effectiveStartDate), item?.effectiveEndDate);
    //const totalGross = getTotalGross(item);
    let estWeeklyNet = 0;
    const hoursPerWeek = item?.hoursPerWeek;
    const hoursPerShift = item?.hoursPerShift;

    const currSplitRates = existingRates?.find(x => x?.splitId === item?.splitId);
    let payRateCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.payRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let overtimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.overTimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let premiumPayCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.premiumPayRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });
    let doubletimeCalculatedValue = getRatesWeeklyCalculatedValue({
      fieldName: PreviewContainerFieldNames.doubletimeRate,
      currSplitRates,
      eachSplit: item,
      hoursPerWeek: item?.hoursPerWeek,
    });

    if (payRateCalculatedValue) {
      estWeeklyNet += payRateCalculatedValue * 0.75;
    }
    if (overtimeCalculatedValue) {
      estWeeklyNet += overtimeCalculatedValue * 0.75;
    }
    if (premiumPayCalculatedValue) {
      estWeeklyNet += premiumPayCalculatedValue * 0.75;
    }
    if (doubletimeCalculatedValue) {
      estWeeklyNet += doubletimeCalculatedValue * 0.75;
    }

    if (tlaEnabled) {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCarAllowance)) {
        const carAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCarAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        estWeeklyNet += carAllowance * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaMealAllowance)) {
        const mealAllowance =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaMealAllowance]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        estWeeklyNet += mealAllowance * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaShiftCompletionBonus)) {
        const shiftCompletionBonus =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaShiftCompletionBonus]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        estWeeklyNet += shiftCompletionBonus * 0.75;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.tlaCellPhoneStipend)) {
        const cellPhoneStipend =
          roundToTwoDecimals(item[PreviewContainerFieldNames.tlaCellPhoneStipend]) * getTlaShiftsPerWeek(hoursPerWeek, hoursPerShift);
        estWeeklyNet += cellPhoneStipend;
      }
    } else {
      if (item?.hasOwnProperty(PreviewContainerFieldNames.mealPerDiem)) {
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.mealPerDiem]) * 7;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.lodgingPerDiem)) {
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.lodgingPerDiem]) * 7;
      }
      if (item?.hasOwnProperty(PreviewContainerFieldNames.cellPhoneStipend)) {
        estWeeklyNet += roundToTwoDecimals(item[PreviewContainerFieldNames.cellPhoneStipend]) * 7;
      }
    }
    const weeklyTotal = estWeeklyNet * duration;
    return acc + weeklyTotal;
  }, 0);
};

export const getStandardFurniture = (standardFurniture: IPlacementMarginFurnitureCost[]) => {
  return standardFurniture?.reduce((acc, item) => {
    return acc + item?.quantity;
  }, 0);
};

export const getSubstitutionValues = (
  currentMarginData: IPlacementMarginDetailsResponse,
  headerData: IPlacementMarginDetailsResponseScenario,
  existingRates: IPlacementMarginOverTimeHourlyRateItem[],
  payPackageDetailsValues,
  brand?: string,
) => {
  const scenarioStartDate = !isUndefined(currentMarginData?.bookingPeriodStartDate)
    ? formatDateObj(currentMarginData?.bookingPeriodStartDate)
    : formatDate(missingDate);
  const scenarioEndDate = !isUndefined(currentMarginData?.bookingPeriodEndDate)
    ? formatDateObj(currentMarginData?.bookingPeriodEndDate)
    : formatDate(missingDate);
  const totalReimbursement = getTotalReimbursement(headerData, brand);
  const assignmentWeek = currentMarginData?.bookingPeriodDuration;
  const isAccepted = headerData?.splits?.some(
    item => item?.healthInsuranceTypeId === PlacementMarginPayPackageStatus.Pending,
  );
  const benefitStatus = isAccepted ? PlacementMarginScenarioStatus.Accepted : PlacementMarginScenarioStatus.Declined;
  const facilityLocation = `${currentMarginData?.facility?.facilityName}, ${
    currentMarginData?.facility?.facilityAddress1
  }, ${currentMarginData?.facility?.facilityAddress2 ? currentMarginData?.facility?.facilityAddress2 + ',' : ''} ${
    currentMarginData?.facility?.facilityCity
  }, ${currentMarginData?.facility?.facilityState}, ${currentMarginData?.facility?.facilityCountry}, ${
    currentMarginData?.facility?.facilityZip ? currentMarginData?.facility?.facilityZip : ''
  }`;
  const weeklyGross = totalWeeklyGross(headerData?.splits, headerData?.tla, existingRates, payPackageDetailsValues);
  const weeklyEstWeeklyNet = totalWeeklyEstWeeklyNet(
    headerData?.splits,
    headerData?.tla,
    existingRates,
    payPackageDetailsValues,
  );

  const shift = headerData?.splits
    ?.filter(item => item?.hoursPerWeek)
    .map(item => ` ${item?.shift} / ${item?.hoursPerWeek} ${i18next.t('marginTool.labels.hrPerweek')}`);
  const filteredShift = [...new Set(shift)];

  const substitutionValues = {
    firstName: currentMarginData?.candidateNameFirst,
    lastName: currentMarginData?.candidateNameLast,
    assignment:
      scenarioStartDate + ' - ' + scenarioEndDate + ` (${assignmentWeek} ${i18next.t('marginTool.labels.weeks')}) `,
    shift: filteredShift?.toString(),
    location: facilityLocation,
    benefit: benefitStatus,
    arrivingTravel: formattedNumber(headerData?.assignment?.travel?.arrivingTravel?.toFixed(2)),
    endingTravel: formattedNumber(headerData?.assignment?.travel?.endingTravel?.toFixed(2)),
    interimTravel: formattedNumber(headerData?.assignment?.travel?.interimTravel?.toFixed(2)),
    flight: formattedNumber(headerData?.assignment?.travel?.amnFlight?.toFixed(2)),
    rentalCar: formattedNumber(headerData?.assignment?.travel?.amnRentalCar?.toFixed(2)),
    total: totalReimbursement > 0 ? String(formattedNumber(totalReimbursement?.toFixed(2))) : undefined,
    totalReimbursement: String(formattedNumber(totalReimbursement?.toFixed(2))),
    totalWeeklyGross: String(formattedNumber(weeklyGross?.toFixed(2))),
    estimatedTotalNetPay: String(formattedNumber(weeklyEstWeeklyNet?.toFixed(2))),
  };
  return substitutionValues;
};

export const getCandidateEmailSubject = (currentMarginData: IPlacementMarginDetailsResponse) => {
  return `AMN Pay Quote for ${currentMarginData?.facility?.facilityName}, ${currentMarginData?.facility?.facilityCity}, ${currentMarginData?.facility?.facilityState}`;
};

export const getApprovalEmailSubject = (
  headerData: IPlacementMarginDetailsResponseScenario,
  placementHeaderData: any,
) => {
  const candidateName = `${placementHeaderData?.candidate?.firstName} ${placementHeaderData?.candidate?.lastName}`;

  return (
    `Booking ${getPayPackageStatusName(headerData?.scenarioStatusId)}` +
    (headerData?.placementId ? ` for PID #${headerData.placementId}` : '') +
    (candidateName ? ` - ${candidateName}` : '') +
    (placementHeaderData?.candidate?.id ? ` (${placementHeaderData.candidate.id})` : '') +
    (placementHeaderData?.facility?.name ? ` - ${placementHeaderData.facility.name}` : '') +
    (placementHeaderData?.facility?.id ? ` (${placementHeaderData.facility.id})` : '') +
    (placementHeaderData?.technologyVendorName ? ` - ${placementHeaderData.technologyVendorName}` : '') +
    (placementHeaderData?.vmsReqNo ? `: #${placementHeaderData.vmsReqNo}` : '')
  );
};

export const getSplitsWithAdditionalPremium = (splits, payPackageDetailsValues) => {
  const splitsWithAdditionalPremiumPay = cloneDeep(splits) || [];
  const additionalPremiumPay = payPackageDetailsValues?.filter(
    x => x.category === 'Pay Rates' && x.subCategory === 'Additional Premium Pay',
  );
  splitsWithAdditionalPremiumPay.forEach(split => {
    // Find the matching premium pay detail for the current split by splitId
    const premiumDetail = additionalPremiumPay.find(detail => detail.splitId === split.splitId);
    if (premiumDetail?.pickListDescription) {
      split.additionalPremiumPay = {
        label: premiumDetail?.pickListDescription,
        object: {
          description: premiumDetail?.pickListDescription,
        },
      };
    }
  });
  return splitsWithAdditionalPremiumPay;
};
export const transformSplitsToPeopleSoftValues = (splits: any[]) => {
  return splits?.map(item => ({
    splitId: item.splitId,
    vms: item.vms?.toString() ?? null,
    other: item.other?.toString() ?? null,
    orientationHours: item.orientationHours?.toString() ?? null,
  })) ?? [];
};
